export const siteRoutes_EN = {
  // Toasts used for challenges
  routes: {
    headlines: {
      main: "Main",
      engagement: "Engagement",
      updates: "Updates",
      profile: "Profile",
      tracker: "Game Tracker",
      studio: "Creator",
      admin: "Admin",
    },
    route: {
      home: "Home",
      zones: "Zones",
      feed: "Feed",
      overview: "Challenges",
      challenges: "Challenges",
      teams: "Teams",
      dailyTasks: "Daily tasks",
      news: "News",
      schedule: "Schedule",
      winners: "Winners",
      settings: "Settings",
      leaderboard: "Leaderboard",
      gamepass: "Game Pass",
      feedback: "Feedback",
      gametracker: "Game Tracker",
      create: {
        challenge: "Create challenge",
        news: "Create news",
      },
      events: "Events",
      submissions: "Submissions",
      admin: {
        raffle: "Find PS winners",
        tclraffle: "Find TCL winner",
        analytics: "Analytics",
      },
    },
  },
};
